import titoPic from "@/public/images/artists/tito.png";
import { Artist } from "@/types/types";

export const tito = {
  id: "258",
  name: "Tito",
  image: titoPic,
  description: `Tito has a light, high-set voice that cuts through the rhythm with easy brightness. His tone is clean and agile, giving everything he sings a sharp, melodic bounce.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ftito-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Afrobeat", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 50,
        high: 70,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
